var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcModalButtonRightCorner = function SvgIcModalButtonRightCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CB300E",
    d: "m40 5.637-6.944-3.485h-4.474L26.9.694h-5.597l-2.46 1.585H9.666L2.275 6.84V12h1.46V6.84l6.043-3.929h21.824l7.274 3.421L40 5.637Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD5B9",
    d: "m38.88 6.331-7.275-3.42H9.782L3.738 6.84V12h1.23V6.902l5.15-3.357h20.145l7.834 3.357.783-.572Z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#AE1F00",
    d: "M30.71 2.153 27.572 0H20.41l-2.572 1.645H8.993L0 6.791l2.277.05 7.392-4.56h9.176l2.46-1.585h5.597l1.683 1.457h2.124Z"
  })));
};
export default SvgIcModalButtonRightCorner;